import React, { useMemo, useState } from "react";
import { Navbar, NavbarBrand, Modal, ModalHeader, ModalBody } from "reactstrap";
import Theme from "../../theme";
import FootprintInputButton from "../../Components/utils/FootprintInputButton";
import SurveyComponent from "./component/Survey1";
import FootpringSvg from "../../assets/Footprints-Logo.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useRequestProcessor } from "../../requestProcessor";
import { submitSurvey } from "../../QueryFunctions/queryfunction";
import { useAtom } from "jotai";
import { activeChildDetail } from "../../AtomStore/store";

const Survey = () => {
  const { useMutationWrapper } = useRequestProcessor();
  const navigate = useNavigate();
  const [activeChild] = useAtom(activeChildDetail);

  const [state, setState] = useState({
    surveyId: useParams(),
    rating: undefined,
    tags: undefined,
    comment: undefined,
  });
  const updateFeedback = useMutationWrapper("raiseIssue", () =>
    submitSurvey(state, navigate)
  );

  useMemo(() => {
    console.log(
      `[Survey] Fetching Survey details for user: ${activeChild?.id}`
    );
  }, [activeChild]);

  const validate = () => {
    console.log("State data");

    if (state.rating === undefined) {
      setState({ ...state, error: "Please Select Rating" });
      return false;
    } else if (state.tags === undefined || state.tags.length === 0) {
      setState({ ...state, error: "Please check the Tags" });
      return false;
    } else if (!state.comment || state.comment.trim() === "") {
      setState({ ...state, error: "Please Enter Comment" });
      return false;
    } else {
      return true;
    }
  };

  const submit = (type) => {
    if (validate()) {
      if (state?.surveyId) {
        updateFeedback.mutate();
      } else {
        setState({ ...state, error: "Survey id missing" });
      }
    }
  };
  return (
    <div
      className="bg-preview"
      style={{
        backgroundImage: "url(" + require("../../assets/bg-pattern.jpg") + ")",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
      }}
    >
      <Navbar color="white" light expand="md" className="shadow mb-5 fixed-top">
        <NavbarBrand href="/" className="m-auto py-2">
          <img src={FootpringSvg} alt="Logo" />
        </NavbarBrand>
      </Navbar>
      <Modal
        className="modal-dialog-centered modal-lg"
        isOpen={true}
        backdrop={false}
      >
        <ModalHeader
          style={{
            background: Theme.colorSecondry,
            fontWeight: "800",
            fontSize: "1.3em",
            color: "#fff",
          }}
        >
          <span className="text-white">Survey</span>
        </ModalHeader>
        <ModalBody>
          <SurveyComponent
            onRatingPressed={(rating) =>
              setState({ ...state, rating, error: undefined })
            }
            getComment={(comment) =>
              setState({ ...state, comment, error: undefined })
            }
            getTags={(answers) => {
              setState(
                {
                  ...state,
                  tags: answers.filter((item) => item.checked === true),
                  error: undefined,
                },
                () => {}
              );
            }}
          />
          {typeof state.error !== "undefined" && (
            <p style={{ color: "red" }}>{state.error}</p>
          )}
          <FootprintInputButton
            onClick={() => {
              submit();
            }}
          />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Survey;
